import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { handleSaveOrUpdate } from "@/api/managementCenter/jobManage";
import TreeSelect from "@/components/TreeSelect.vue";
import { getRoleList, getDeptTree } from "@/api/managementCenter/otherApi";
import chargePerson from "@/components/management/reportManage/chargePerson.vue";
export default {
  name: "addJobDialog",
  components: {
    TreeSelect: TreeSelect,
    chargePerson: chargePerson
  },
  props: [],
  data: function data() {
    return {
      show: false,
      loading: false,
      title: "",
      type: "",
      selectRoleList: [],
      deptList: [],
      userText: "",
      userId: [],
      mapKey: {
        id: "id",
        // ID
        label: "name",
        // 显示名称
        children: "children" //子级字段名

      },
      roleList: [],
      departmentData: [],
      form: {
        postId: "",
        postName: "",
        belongDeptId: "",
        deptList: [],
        description: "",
        userList: [],
        roleList: []
      },
      rules: {
        postName: [{
          required: true,
          message: "请输入岗位名称",
          trigger: "blur"
        }],
        belongDeptId: [{
          required: true,
          message: "请选择所属部门",
          trigger: "change"
        }],
        deptList: [{
          required: true,
          message: "请选择管辖部门",
          trigger: "change"
        }],
        roleList: [{
          required: true,
          message: "请选择岗位角色",
          trigger: "change"
        }],
        userList: [{
          required: true,
          message: "请选择人员",
          trigger: "change"
        }]
      },
      personData: {
        userData: [],
        state: false,
        disabled: false,
        data: []
      }
    };
  },
  computed: {},
  mounted: function mounted() {},
  methods: {
    //获取部门数据
    getDeptTreeData: function getDeptTreeData() {
      var _this = this;

      getDeptTree().then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          if (data.data && data.data.length > 0) {
            if (data.data[0].id == 1) {
              _this.departmentData = data.data[0].children;
            } else {
              _this.departmentData = data.data;
            }
          }

          if (_this.type == "edit") {
            _this.$nextTick(function () {
              // 编辑时部门回显
              _this.$refs.deptSingle.setKey(_this.form.belongDeptId);

              _this.$refs.deptDouble.setKeys(_this.deptList);
            });
          }
        }
      }).catch(function (err) {});
    },
    setDeptSingleMenu: function setDeptSingleMenu(key, data) {
      //获取子组件值
      this.form.belongDeptId = data.id;
    },
    setDeptDoubleMenu: function setDeptDoubleMenu(key, data) {
      //获取子组件值
      this.deptList = (data || []).map(function (item) {
        return item.id;
      });
    },
    //获取角色列表
    getRoleListData: function getRoleListData() {
      var _this2 = this;

      getRoleList().then(function (_ref2) {
        var data = _ref2.data;

        if (data.code == 0) {
          _this2.roleList = data.data.map(function (i) {
            return _objectSpread(_objectSpread({}, i), {}, {
              roleId: i.roleId + ""
            });
          });
        }
      }).catch(function (err) {});
    },
    //显示人员选择
    addUser: function addUser() {
      this.$refs.personModal.loadData();
      this.personData.state = true;
    },
    //选择人员
    closePerson: function closePerson(value) {
      if (!value.mans) {
        this.personData.state = false;
        return;
      }

      var mans = value.mans || [];
      this.userText = mans.map(function (item) {
        return item.name;
      }).join("、");
      this.userId = mans.map(function (item) {
        return item.userId;
      });
      this.personData.state = false;
      this.personData.data = mans.map(function (item) {
        return {
          userId: item.userId,
          name: item.name
        };
      });
      this.personData.userData = this.userId;
    },
    // 显示弹框
    dialogShow: function dialogShow(type, data) {
      var _this3 = this;

      this.type = type; // 重置表单、显示弹框

      this.show = true;
      this.$nextTick(function () {
        _this3.$refs["ruleForm"].resetFields();

        switch (type) {
          case "add":
            _this3.title = "新增岗位";
            _this3.form = {
              postId: "",
              postName: "",
              belongDeptId: "",
              deptList: [],
              description: "",
              userList: [],
              roleList: []
            };
            _this3.selectRoleList = [];
            _this3.deptList = [];
            _this3.userText = "";
            _this3.userId = [];
            break;

          case "edit":
            _this3.title = "编辑岗位";
            _this3.form = {
              postId: data.postId,
              postName: data.postName,
              belongDeptId: data.belongDeptId,
              deptList: [],
              description: data.description,
              userList: [],
              roleList: []
            };
            _this3.selectRoleList = (data.roleList || []).map(function (i) {
              return i.roleId;
            });
            _this3.deptList = (data.deptList || []).map(function (i) {
              return i.deptId;
            });
            _this3.userText = (data.userList || []).map(function (i) {
              return i.username;
            }).join("、");
            _this3.userId = (data.userList || []).map(function (i) {
              return i.userId;
            });
            _this3.personData.data = (data.userList || []).map(function (i) {
              return {
                userId: i.userId,
                name: i.username
              };
            });
            _this3.personData.userData = _this3.userId;
            break;
        }
      });
    },
    saveOrUpdate: function saveOrUpdate() {
      var _this4 = this;

      this.loading = true;
      handleSaveOrUpdate(this.form).then(function (_ref3) {
        var data = _ref3.data;
        _this4.loading = false;

        if (data.code == 0) {
          _this4.$message.success("保存成功!");

          _this4.show = false;

          _this4.$emit("saveSuccess");
        } else {
          _this4.$message.warning(data.msg || "保存失败!");
        }
      }).catch(function (err) {
        _this4.loading = false;

        _this4.$message.error("服务器异常!");
      });
    },
    // 确定提交
    submitForm: function submitForm(formName) {
      var _this5 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this5.saveOrUpdate();
        } else {
          return false;
        }
      });
    }
  },
  watch: {
    deptList: function deptList(val) {
      this.form.deptList = (val || []).map(function (i) {
        return {
          deptId: i
        };
      });
    },
    selectRoleList: function selectRoleList(val) {
      this.form.roleList = (val || []).map(function (i) {
        return {
          roleId: i
        };
      });
    },
    userId: function userId(val) {
      this.form.userList = (val || []).map(function (i) {
        return {
          userId: i
        };
      });
    },
    show: function show(value) {
      if (value) {
        // 打开弹框时，获取岗位和角色数据
        this.getDeptTreeData();
        this.getRoleListData();
      } else {
        this.personData.data = [];
        this.personData.userData = [];
      }
    }
  },
  filters: {}
};